import { DefaultStaticsContext } from "./StatisticsContext";
export class LayaGL {
}
LayaGL.statAgent = new DefaultStaticsContext();
